import { Dayjs } from 'dayjs';
import React from 'react';
import { BhiFormDialog, Button } from 'src/UIKit';
import { BhiDateTimePicker } from 'src/components/Inputs/BhiDateTimePicker';

type ScheduleMessageDialogProps = {
  open: boolean;
  value: Dayjs | null;
  onClose: () => void;
  onChange: (value: Dayjs | null) => void;
  onConfirm: () => void;
};

const ScheduleMessageDialog = ({
  open,
  value,
  onClose,
  onChange,
  onConfirm,
}: ScheduleMessageDialogProps) => {
  return (
    <BhiFormDialog
      title="Schedule message"
      isOpen={open}
      onClose={onClose}
      actions={
        <>
          <Button variant="outlined" onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={onConfirm} disabled={!value}>Ok</Button>
        </>
      }
    >
      <BhiDateTimePicker value={value} onChange={onChange} />
    </BhiFormDialog>
  );
};

export default ScheduleMessageDialog;
